import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

function RedirectPage() {
  const { shortCode } = useParams(); // Obtém o código da URL a partir da rota
  const apiBaseUrl = "https://urlshortapi.sturion.net";

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        // Busca a URL correspondente ao código na API
        const response = await axios.get(`${apiBaseUrl}/${shortCode}`);
        const { url } = response.data;

        if (url) {
          // Redireciona o usuário para a URL obtida
          window.location.href = url;
        } else {
          alert("Código não encontrado!");
        }
      } catch (error) {
        console.error("Erro ao buscar a URL:", error);
        alert("Erro ao redirecionar. Código inválido ou não encontrado.");
      }
    };

    fetchAndRedirect();
  }, [shortCode]);

  return <div>Redirecionando...</div>;
}

export default RedirectPage;